import { render, staticRenderFns } from "./TeamCrestSlots.vue?vue&type=template&id=2089e69b&scoped=true"
import script from "./TeamCrestSlots.vue?vue&type=script&lang=js"
export * from "./TeamCrestSlots.vue?vue&type=script&lang=js"
import style0 from "./TeamCrestSlots.vue?vue&type=style&index=0&id=2089e69b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089e69b",
  null
  
)

export default component.exports